'use strict'
import { request } from '../../plugins/http'

export default async ({userId, accessType, callId, userType}) => {
    return await request.post('/controleProdutividade', {userId, accessType, callId, userType})
}